import { lazy, type ComponentType } from 'react'
import type { ConsoleScreenProps } from './types'

/**
 * A console screen loaded on first use.
 *
 * ⚠️ WHY EVERY TIER'S SCREENS ARE LAZY. The registry is imported by AppRouter,
 * so a static import here puts all four consoles — the operator's alone is the
 * size of the old super-admin dashboard — in the bundle a child's tablet and a
 * marketing visitor download. Lazy, each screen is its own chunk, fetched the
 * first time its route opens. The route table and nav stay synchronous, so
 * routing and the sidebar never wait.
 *
 * Call it ONCE per screen at module scope: two routes that share a screen must
 * share the same lazy component, or React would remount it between them (the
 * parent tier relies on staying mounted across its tabs).
 */
export function lazyScreen<M>(load: () => Promise<M>, pick: (m: M) => ComponentType<ConsoleScreenProps>): ComponentType<ConsoleScreenProps> {
  return lazy(async () => ({ default: pick(await load()) }))
}
